import { resourceReducer, getResources } from 'redux-resource';

export default resourceReducer('quickCarrierRequests');

export const getQuickCarrierRequests = (state, subId, page = 1) =>
  getResources(state, `quickCarrierRequests_${subId}_${page}`);
